export const UNDER_REVIEW = 'under_review';
export const WAITING_FOR_VALIDATION = 'waiting_for_validation';
export const STEP_TWO = 'step_two';
export const STEP_THREE = 'step_three';
export const STEP_FOUR = 'step_four';
